(function ($) {
// Backbone View for tooltips
    GroupTooltipPhoto = Backbone.View.extend({
        initialize: function (options) {
            var layout = model.get('layout');
            // we set current block on call, so we need options array to bind data properly
            this.options = options;
            _.bindAll(this, 'bindings');
            var model_base = 'styles.' + layout + '.';
            $('#a-slide-panel [name="group_' + this.options.field_name + '_size_select"]').val(model.get(model_base + 'photo_size')).fsdropdown('update');
            if (model.get(model_base + 'photo_size') == 'a-full') {
                $('.' + this.options.field_name + '_width', aet_panel).hide();
                $('.' + this.options.field_name + '_top_margin', aet_panel).hide();
            }
        },
        bindings: function () {
            var layout = model.get('layout');
            var result = {};
            var field = this.options.field_name;
            var field_model = 'styles.' + layout + '.' + field;
            result['[name="group_' + field + '_shape"]'] = field_model + '_shape'; // photo shape
            result['[name="group_' + field + '_size"]'] = field_model + '_size'; // photo size
            result['[name="group_' + field + '_width"]'] = field_model + '_width'; // photo width
            result['[name="group_' + field + '_top_margin"]'] = field_model + '_top_margin'; // block top margin
            result['.btn-group-photo-shape'] = {
                observe: field_model + '_shape',
                update: function ($el, val, model, options) {
                    $el.find('.btn').removeClass('active');
                    $el.find('input').val(val);
                    $el.find('.' + this.options.field_name + '_shape_' + val).addClass('active');
                }
            };
            return result;
        },
        render: function () {
            this.stickit();
            return this;
        },
        close: function () {
            this.unstickit();
        }
    });
})(jQuery);